import { useEffect, useState } from 'react';
import { labelStore } from '@/store';

const { getLabelTree } = labelStore;

function useLabel (): any[] {
  const [options, setOptions] = useState<any[]>([]);

  const searchLabel = async () => {
    const result = await getLabelTree();
    if (result) {
      setOptions(result);
    }
  };


  useEffect(() => {
    searchLabel();
  }, []);

  return options
  ;
};

export default useLabel;
